import theme from "@/styles/theme"
import { colors } from "@/styles/colors"

export const BLOCK_SECTION_BORDER_RADIUS = theme.spacing(1)

export const BLOCK_HANDLE_SIZE = theme.spacing(2)

export const BLOCK_BODY_SECTION_EDITOR_WIDTH = "468px"

export const NOT_CONNECTED_LINE_COLOR = colors.yellow[400]

export const CONNECTED_LINE_COLOR = colors.getPrimaryColor()

export const CONNECTION_SELECTED_COLOR = colors.green[600]
